// sides - not an enum for backwards compat
export const FrontSide = 0;
export const BackSide = 1;
export const DoubleSide = 2;